// Top-level quickview metrics for the board. Pure + testable. Adapted from the
// old status-based ProposalTracker stats to the stage model:
//   Active pipeline: Pipeline Value (submitted $), Awaiting Response (submitted
//     count), Overdue (active proposals past dueDate).
//   Year to date: Total Proposals, Total Submitted Value, Funded (count + $),
//     Funded Rate (funded / (funded + not_selected)).
// Computed over whatever proposal set is passed in — the board passes the
// filtered set so the numbers track the active filters.
import { isPreSubmission } from "./stages.js";
import { dueUrgency } from "./urgency.js";

const num = (v) => Number(v) || 0;

function inCurrentYear(p, year) {
  const d = p.submissionDate || p.createdAt;
  if (!d || typeof d !== "string") return false;
  const dt = new Date(d.length === 10 ? d + "T00:00:00" : d);
  return !Number.isNaN(dt.getTime()) && dt.getFullYear() === year;
}

export function computeMetrics(proposals, now = new Date()) {
  const list = Array.isArray(proposals) ? proposals : [];

  const submitted = list.filter((p) => p.stage === "submitted");
  const pipelineValue = submitted.reduce((s, p) => s + num(p.value), 0);
  const awaiting = submitted.length;
  const overdue = list.filter(
    (p) => isPreSubmission(p.stage) && dueUrgency(p.dueDate, now)?.level === "overdue"
  ).length;

  const year = now.getFullYear();
  const ytd = list.filter((p) => inCurrentYear(p, year));
  const ytdTotal = ytd.length;
  const ytdValue = ytd.reduce((s, p) => s + num(p.value), 0);
  const funded = ytd.filter((p) => p.stage === "funded");
  const fundedCount = funded.length;
  const fundedValue = funded.reduce((s, p) => s + num(p.value), 0);
  const decided = ytd.filter((p) => p.stage === "funded" || p.stage === "not_selected").length;
  const fundedRate = decided > 0 ? Math.round((fundedCount / decided) * 100) : 0;

  return { pipelineValue, awaiting, overdue, ytdTotal, ytdValue, fundedCount, fundedValue, fundedRate };
}
